import { Navigate } from "react-router-dom";
import MainLayout from "../MainLayout";
import Loadable from "./RouteLoad/Loadable";
import { lazy } from "react";
import { Logout } from ".";
import UserList from "../Configurations/UserManagement";
import SMSCampaignCreation from "../campaign-creation/BulkCampaigns";
// import OptOutTemplate from "../Configurations/opt-out-template-message";

// const FlashCampaignCreation = Loadable(lazy(() => import("../campaign-creation/FlashCampaignCreation")));
// const FlashCampaign = Loadable(lazy(() => import("../Reoprts/Flash-report")));
const MasksList = Loadable(lazy(() => import("../Configurations/MaskManagement/masks-list")));
const ViewCampaign = Loadable(lazy(() => import("../Reoprts/view-uses/campaign-uses-view")));
const BlackoutTime = Loadable(lazy(() => import("../Configurations/black-out-time/black-out-time")));
const AddEditRateCard = Loadable(lazy(() => import("../Configurations/rate-card/add-edit-rate-card")));
const Dashboard = Loadable(lazy(() => import("../Dashboard/index")));
const OwnerList = Loadable(lazy(() => import("../Configurations/UserManagement/ParentUsers/user-list")));
const ChildUserList = Loadable(lazy(() => import("../Configurations/UserManagement/api-user-management/child-user-list")));
const ChannelList = Loadable(lazy(() => import("../Configurations/Channel/channel-list")));
const RateCardList = Loadable(lazy(() => import("../Configurations/rate-card/rate-cards-list")));
const UnauthorizedAccess = Loadable(lazy(() => import("../../utils/ui-components/UnauthorizedAccess")));
const TaxManagement = Loadable(lazy(() => import("../Configurations/tax-management/tax-management")));
const CampaignReports = Loadable(lazy(() => import("../Reoprts/CampaignReport")));
const CampaignCreation = Loadable(lazy(() => import("../campaign-creation")));

function AdminAuthorizedRoutes(role: any) {
  return [
    {
      path: "/",
      element: <MainLayout role={role} />,
      children: [
        {
          path: "/",
          element: <Dashboard />,
        },
        {
          path: "dashboard",
          element: <Dashboard />,
        },
        {
          path: "mask",
          children: [
            {
              path: "list",
              element: <MasksList role={role} />,
            },
          ],
        },
        {
          path: "user",
          children: [
            {
              path: "list",
              element: <UserList role={role} />,
            },
          ],
        },
        {
          path: "api-user",
          children: [
            {
              path: "list",
              element: <ChildUserList />,
            },
          ],
        },
        {
          path: "config",
          children: [
            {
              path: "channel",
              element: <ChannelList />,
            },
            {
              path: "rate-card",
              element: <RateCardList />,
            },
            {
              path: "rate-card/:id",
              element: <AddEditRateCard />,
            },
            // {
            //   path: "opt-out-message",
            //   element: <OptOutTemplate />,
            // },
            {
              path: "tax-management",
              element: <TaxManagement />,
            },
            {
              path: "blackout-time",
              element: <BlackoutTime />,
            },
          ],
        },
        {
          path: "reports",
          children: [
            {
              path: "campaign-report",
              element: <CampaignReports />,
            },
            {
              path: "api-report/:campaigntype/:id",
              element: <ViewCampaign />,
            },
            {
              path: "flash-report/:campaigntype/:id",
              element: <ViewCampaign />,
            },
            {
              path: "bulk-sms-report/:campaigntype/:id",
              element: <ViewCampaign />,
            },
            {
              path: "pending-report/:campaigntype/:id",
              element: <ViewCampaign />,
            },
          ],
        },

        {
          path: "campaign-creation",
          children: [
            {
              path: "",
              element: <CampaignCreation role={role} />,
            },
            {
              path: "sms",
              element: <SMSCampaignCreation role={role} />,
            },
          ],
        },
        // {
        //   path: "campaign-creation",
        //   children: [
        //     {
        //       path: "",
        //       element: <CampaignCreation role={role} />,
        //     },
        //   ],
        // },
      ],
    },
    {
      path: "unauthorized",
      element: <UnauthorizedAccess />,
    },
    {
      path: "",
      element: <Navigate to="/dashboard" />,
    },
    {
      path: "login",
      element: <Navigate to="/dashboard" />,
    },
    {
      path: "logout",
      element: <Logout />,
    },
    {
      path: "verify-login",
      element: <Navigate to="/dashboard" />,
    },
    {
      path: "*",
      element: <Navigate to="/unauthorized" />,
    },
  ];
}

export default AdminAuthorizedRoutes;
